<template>
  <div class="col-sm-3 mb-5 mb-xl-10" >
    <div class="card card-flush h-lg-100">
      <div class="card-header pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bolder text-dark">{{$t('setting.setting_society')}}</span>
        </h3>
      </div>
      <div class="card-body pt-5">
        <router-link :to="'settings-society/company'">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.companyInformation')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
        <router-link :to="'settings-society/departments'" v-if="$can(abilities.VIEW_DEPARTMENT)" >
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.departments')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
        <router-link :to="'settings-society/taxes'" v-if="$can(abilities.VIEW_TAX) && $canAccess(moduleAbilities.GENERAL_INVOICE)">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.taxes')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
        <router-link :to="'settings-society/post'" v-if="$can(abilities.VIEW_POST_OFFICE)">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.post')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
        <router-link :to="'settings-society/normalization'" v-if="$can(abilities.VIEW_NORMALIZED_KEY) && $canAccess(moduleAbilities.GENERAL_INVOICE)">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.normalization')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
 import abilities from "@/composables/abilities";
 import moduleAbilities from "@/composables/moduleAbilities";

</script>
<style scoped>

</style>